import { CENTERLINE_DEFAULT_COLOR, CARINA_DEFAULT_COLOR } from '../../../../settings/centerline';

const OUTSIDE_AIRWAY_COLOR = 0xff0000;

export default function checkCenterlineBounds() {
  return (notify, getSceneState) => {
    const { centerline, scene } = getSceneState();

    let isOutsideAirway = false;

    centerline.removeInvalidBranches();

    centerline.visualize(scene, CENTERLINE_DEFAULT_COLOR);
    centerline.visualizeCarina(scene, CARINA_DEFAULT_COLOR);

    centerline.traverse(b => {
      if (!b.isEnclosedInAirway()) {
        b.visualize(scene, OUTSIDE_AIRWAY_COLOR);

        isOutsideAirway = true;
      }
    });

    return !isOutsideAirway;
  };
}
